import { Component, OnInit } from '@angular/core';
import { NbLayoutDirectionService, NbLayoutDirection } from '@nebular/theme/services/direction.service';

@Component({
    selector: 'ngx-app',
    template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

    constructor(private directionService: NbLayoutDirectionService) {
    }

    ngOnInit(): void {
        this.directionService.setDirection(NbLayoutDirection.RTL);
    }
}
